import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useEffect } from 'react';
import { useStoreActions } from '~/contexts';
import { ErrorResponse } from '~/infra/ErrorResponse';
import { tasksStore, useTasksDrawerStore } from './tasksStore';
async function resyncOne(getJob, task) {
    if (task.status === 'ready' || task.status === 'failed') return;
    try {
        const res = await getJob(task.jobId);
        tasksStore.updateTask(task.jobId, _object_spread({
            status: res.status,
            progress: res.progress
        }, res.downloadUrl != null ? {
            downloadUrl: res.downloadUrl
        } : {}, res.fileName != null ? {
            fileName: res.fileName
        } : {}));
    } catch (err) {
        if (new ErrorResponse(err).hasStatus([
            404
        ])) {
            tasksStore.removeTask(task.jobId);
        }
    }
}
export function useTaskResync() {
    const { api } = useStoreActions();
    const namespaceKey = useTasksDrawerStore((s)=>s.namespaceKey);
    useEffect(()=>{
        const sweep = ()=>{
            for (const t of tasksStore.getSnapshotTasks()){
                void resyncOne(api.pdf.getJob, t);
            }
        };
        sweep();
        const onVisibilityChange = ()=>{
            if (document.visibilityState === 'visible') sweep();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>document.removeEventListener('visibilitychange', onVisibilityChange);
    }, [
        api,
        namespaceKey
    ]);
}
